
import { PAGE_TYPE, QUERY_WORK_WITH_US } from "./-index.query";
import { seoMixin, pageMixin } from "~/mixins";

const UID = "work-with-us";

export default {
  mixins: [seoMixin, pageMixin],

  async asyncData({ app }) {
    const { [PAGE_TYPE]: data } = await app.$prismicGql.request({
      query: QUERY_WORK_WITH_US,
      variables: { uid: UID },
    });

    return {
      slices: data.slices,
      title: data.title,
      uid: UID,
      pageType: PAGE_TYPE,
      metaTitle: data.metaTitle,
      metaDescription: data.metaDescription,
      metaRobots: data.metaRobots,
      metaFields: { _linkType: data._linkType, _meta: data._meta },
    };
  },
};
